export const sapboneConfiguration = {
  sapbone_configurations: `Configuraciones de SAPBOne`,
  sapbone_sync_history: `Historial de sincronización de SAPBOne`,
  sapbone_never: `Nunca`,
  sapbone_sync_in_progress: `Sincronización en curso`,
  sapbone_last_sync: `Última sincronización`,
  sapbone_selected_sync: `Sincronización seleccionada`,
  sapbone_recent_syncs: `Sincronizaciones recientes (últimas {{shown}} de {{total}})`,
  sapbone_no_history: `Aún no hay sincronizaciones. Seleccione Sincronizar ahora para ejecutar la primera.`,
  sapbone_sync_start_date: `Sincronización iniciada`,
  sapbone_no_entities: `No se sincronizaron entidades en esta ejecución.`,
  sapbone_no_changes: `Sin cambios`,
  sapbone_created: `Creados`,
  sapbone_updated: `Actualizados`,
  sapbone_failed_entities: `Entidades con error`,
  sapbone_entity: `Entidad`,
  sapbone_failed: `Error`,
  sapbone_status_Success: `Correcta`,
  sapbone_status_PartialSuccess: `Parcialmente correcta`,
  sapbone_status_Failed: `Fallida`,
  sapbone_result_summary: `{{created}} creados, {{updated}} actualizados`,
  sapbone_duration: `Duración {{value}}`,
  sapbone_duration_min_sec: `{{min}} min {{sec}} s`,
  sapbone_duration_sec: `{{sec}} s`,
  sapbone_date_range: `{{date}}, {{start}} a {{end}}`,
  sapbone_detail_MissingItemCode: `{{count}} con líneas sin código de artículo`,
  sapbone_close: `Cerrar`,
  sapbone_entity_Vendor: `Proveedores`,
  sapbone_entity_PaymentTerm: `Condiciones de pago`,
  sapbone_entity_PaymentMethod: `Métodos de pago`,
  sapbone_entity_DeliveryNote: `Albaranes`,
  sapbone_entity_PurchaseOrder: `Pedidos de compra`,
  sapbone_entity_Item: `Artículos`,
  sapbone_entity_VatGroup: `Grupos de IVA`,
  sapbone_entity_Account: `Cuentas`,
  sapbone_entity_CostCenter: `Centros de coste`,
  sapbone_output_connector: {
    baseurl: "URL base",
    username: "Nombre de usuario",
    password: "Contraseña",
  },
};
